/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_OpenInputs */

const en_directory_submit_review_open = /** @type {(inputs: Directory_Submit_Review_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review submission`)
};

const zh_directory_submit_review_open = /** @type {(inputs: Directory_Submit_Review_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看并审核提交`)
};

/**
* | output |
* | --- |
* | "Review submission" |
*
* @param {Directory_Submit_Review_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_open = /** @type {((inputs?: Directory_Submit_Review_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_open(inputs)
	return zh_directory_submit_review_open(inputs)
});
export { directory_submit_review_open as "directory.submit.review.open" }